import { atom } from "jotai";

// Task State Atoms
export const tasksAtom = atom([]);
export const allTasksAtom = atom([]); // All tasks in the workspace for hierarchy navigation
export const selectedTaskAtom = atom(null);
export const returnedBubblesAtom = atom([]);
export const hasRunAtom = atom(false);
export const isDraggingBubbleAtom = atom(false);
export const popAtom = atom(false);
export const popPositionAtom = atom({
  x: window.innerWidth / 2 - 250,
  y: window.innerHeight / 2 - 250,
  color: "default",
});
export const categoryImagesAtom = atom({});
export const hoveredTaskAtom = atom(null);

// Task Hierarchy State Atoms
export const currentProjectIdAtom = atom(null); // null for top-level view, task_id for project view
export const selectedTasksAtom = atom([]); // For multi-select functionality
export const projectBreadcrumbAtom = atom([]); // For navigation breadcrumb

export const recurringRulesAtom = atom([]);

// Task Form State Atoms
export const taskNameAtom = atom("");
export const effortAtom = atom(null);
export const impactAtom = atom(null);
export const dueDateAtom = atom(null);
export const descriptionAtom = atom("");
export const categoryAtom = atom("");
